import {
    InputControl,
    Row,
    Col,
    Container,
    RadioControl,
    FieldsetControl,
} from '@si-armes/dsfr-react';
import React, { useEffect, useId } from 'react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
    FEATURE_APPEL_API_FFTIR,
    isFeatureActive,
} from '../../../../../../../components/FeatureFlipping/featureFlipping.func';

const InformationLicencie = ({ featureFlipping }) => {
    const { register, watch, formState, unregister, setError, clearErrors } = useFormContext();
    const { message } = useSelector((state) => state.compte.creer.renseignerIdentite);

    useEffect(() => {
        if (watch('selectLicencieOrAncienLicencieTir') !== 'isLicencie') {
            unregister('versoLicenceTir');
        }
    }, [watch('selectLicencieOrAncienLicencieTir')]);

    useEffect(() => {
        if (watch('selectLicencieOrAncienLicencieBallTrap') !== 'isLicencie') {
            unregister('versoLicenceBallTrap');
        }
    }, [watch('selectLicencieOrAncienLicencieBallTrap')]);

    useEffect(() => {
        if (watch('selectLicencieOrAncienLicencieSki') !== 'isLicencie') {
            unregister('versoLicenceSki');
        }
    }, [watch('selectLicencieOrAncienLicencieSki')]);

    useEffect(() => {
        const messagesErreur = ['Le numéro de Licence', 'Ce numéro de licence'];
        if (message && messagesErreur.some((val) => message.includes(val))) {
            setError('numeroLicenceSki');
        }
    }, [message]);

    return (
        <Container fluid={false}>
            <Row>
                <Col col={12}>
                    <h3 data-testid="informations-licence">Informations sur la licence</h3>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="margin-bottom-sm">
                        Veuillez sélectionner votre ou vos fédérations{' '}
                        <span className="text-red">*</span>
                    </p>
                    <p className="fr-text--sm margin-top-sm">
                        {' '}
                        Numéro et import de la Licence facultatifs pour les anciens licenciés
                    </p>
                </Col>
            </Row>
            <Row gutters>
                <Col col={12} lg={4}>
                    <FieldsetControl
                        legend="Fédération Française de Tir"
                        id="selectLicencieOrAncienLicencieTir"
                        state={formState.errors?.selectLicencieOrAncienLicencieTir ? 'error' : null}
                        message={formState.errors?.selectLicencieOrAncienLicencieTir?.message}
                    >
                        <RadioControl
                            id={useId()}
                            label="Licencié"
                            value="isLicencie"
                            {...register('selectLicencieOrAncienLicencieTir')}
                        />
                        <RadioControl
                            id={useId()}
                            label="Ancien licencié"
                            value="isAncienLicencie"
                            {...register('selectLicencieOrAncienLicencieTir')}
                        />
                    </FieldsetControl>
                    <InputControl
                        id="numeroLicenceTir"
                        name="numeroLicenceTir"
                        label={`Numéro de licence de Tir ${
                            watch('selectLicencieOrAncienLicencieTir') === 'isLicencie' ? '*' : ''
                        }`}
                        disabled={!watch('selectLicencieOrAncienLicencieTir')}
                        {...register('numeroLicenceTir')}
                        uppercase
                    />
                    {!isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR) &&
                        watch('selectLicencieOrAncienLicencieTir') && (
                            <>
                                <InputFiles
                                    name="versoLicenceTir"
                                    label="Importer la licence"
                                    error={
                                        formState.errors ? formState.errors.versoLicenceTir : null
                                    }
                                    required={
                                        watch('selectLicencieOrAncienLicencieTir') === 'isLicencie'
                                    }
                                />
                            </>
                        )}
                </Col>
                <Col col={12} lg={4}>
                    <FieldsetControl
                        legend="Fédération Française de Ball-Trap"
                        id="selectLicencieOrAncienLicencieBallTrap"
                        state={
                            formState.errors?.selectLicencieOrAncienLicencieBallTrap
                                ? 'error'
                                : null
                        }
                        message={formState.errors?.selectLicencieOrAncienLicencieBallTrap?.message}
                    >
                        <RadioControl
                            id={useId()}
                            label="Licencié"
                            value="isLicencie"
                            {...register('selectLicencieOrAncienLicencieBallTrap')}
                        />
                        <RadioControl
                            id={useId()}
                            label="Ancien licencié"
                            value="isAncienLicencie"
                            {...register('selectLicencieOrAncienLicencieBallTrap')}
                        />
                    </FieldsetControl>
                    <InputControl
                        id="numeroLicenceBallTrap"
                        name="numeroLicenceBallTrap"
                        label={`Numéro de licence de Ball-Trap ${
                            watch('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie'
                                ? '*'
                                : ''
                        }`}
                        disabled={!watch('selectLicencieOrAncienLicencieBallTrap')}
                        {...register('numeroLicenceBallTrap')}
                        uppercase
                    />
                    {watch('selectLicencieOrAncienLicencieBallTrap') && (
                        <>
                            <InputFiles
                                name="versoLicenceBallTrap"
                                label="Importer la licence"
                                error={
                                    formState.errors ? formState.errors.versoLicenceBallTrap : null
                                }
                                required={
                                    watch('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie'
                                }
                            />
                        </>
                    )}
                </Col>
                <Col col={12} lg={4}>
                    <FieldsetControl
                        legend="Fédération Française de Ski"
                        id="selectLicencieOrAncienLicencieSki"
                        state={formState.errors?.selectLicencieOrAncienLicencieSki ? 'error' : null}
                        message={formState.errors?.selectLicencieOrAncienLicencieSki?.message}
                    >
                        <RadioControl
                            id={useId()}
                            label="Licencié"
                            value="isLicencie"
                            {...register('selectLicencieOrAncienLicencieSki')}
                        />
                        <RadioControl
                            id={useId()}
                            label="Ancien licencié"
                            value="isAncienLicencie"
                            {...register('selectLicencieOrAncienLicencieSki')}
                        />
                    </FieldsetControl>
                    <InputControl
                        id="numeroLicenceSki"
                        name="numeroLicenceSki"
                        label={`Numéro de licence de Ski ${
                            watch('selectLicencieOrAncienLicencieSki') === 'isLicencie' ? '*' : ''
                        }`}
                        disabled={!watch('selectLicencieOrAncienLicencieSki')}
                        {...register('numeroLicenceSki')}
                        uppercase
                        state={formState.errors?.numeroLicenceSki ? 'error' : null}
                        message={formState.errors?.numeroLicenceSki?.message}
                        onChange={() => clearErrors('numeroLicenceSki')}
                    />
                    {watch('selectLicencieOrAncienLicencieSki') && (
                        <>
                            <InputFiles
                                name="versoLicenceSki"
                                label="Importer la licence"
                                error={formState.errors ? formState.errors.versoLicenceSki : null}
                                required={
                                    watch('selectLicencieOrAncienLicencieSki') === 'isLicencie'
                                }
                            />
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

InformationLicencie.propTypes = {
    featureFlipping: PropTypes.shape({
        feature_appel_api_fftir: PropTypes.bool.isRequired,
    }),
};

export default InformationLicencie;
